import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import ScrollToTop from "./components/ScrollToTop";
import SecureAuth from "./components/SecureAuth";
import Login from "./components/Login";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import MBTITest from "./pages/MBTITest";
import TestIQ from "./pages/TestIQ";
import TestEQ from "./pages/TestEQ";
import TestDISC from "./pages/TestDISC";
import HollandCodes from "./pages/HollandCodes";
import TestResult from "./pages/TestResult";
import QuestionManager from "./admin/QuestionManager";
import "./App.css";

function App() {
  // Load and apply header/footer code from admin settings
  useEffect(() => {
    const loadHeaderFooterCode = () => {
      const savedSettings = localStorage.getItem("header_footer_settings");
      if (savedSettings) {
        try {
          const settings = JSON.parse(savedSettings);

          // Apply head code
          if (settings.enable_head && settings.head_code) {
            const existingHead = document.getElementById("custom-head-code");
            if (existingHead) existingHead.remove();

            const headContainer = document.createElement("div");
            headContainer.id = "custom-head-code";
            headContainer.innerHTML = settings.head_code;
            document.head.appendChild(headContainer);
          }

          // Apply body code
          if (settings.enable_body && settings.body_code) {
            const existingBody = document.getElementById("custom-body-code");
            if (existingBody) existingBody.remove();

            const bodyContainer = document.createElement("div");
            bodyContainer.id = "custom-body-code";
            bodyContainer.innerHTML = settings.body_code;
            document.body.insertBefore(bodyContainer, document.body.firstChild);
          }

          // Apply footer code
          if (settings.enable_footer && settings.footer_code) {
            const existingFooter =
              document.getElementById("custom-footer-code");
            if (existingFooter) existingFooter.remove();

            const footerContainer = document.createElement("div");
            footerContainer.id = "custom-footer-code";
            footerContainer.innerHTML = settings.footer_code;
            document.body.appendChild(footerContainer);
          }
        } catch (error) {
          console.warn("Failed to load header/footer settings:", error);
        }
      }
    };

    loadHeaderFooterCode();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/test-mbti" element={<MBTITest />} />
            <Route path="/test-iq" element={<TestIQ />} />
            <Route path="/test-eq" element={<TestEQ />} />
            <Route path="/test-disc" element={<TestDISC />} />
            <Route path="/holland-codes" element={<HollandCodes />} />
            <Route path="/test-result" element={<TestResult />} />
            <Route
              path="/haidang"
              element={
                <SecureAuth>
                  <QuestionManager />
                </SecureAuth>
              }
            />
          </Routes>
        </main>
        <Routes>
          <Route path="*" element={<Footer />} />
        </Routes>
        <BackToTop />
      </div>
    </Router>
  );
}

export default App;
